import * as React from "react";
import { connect } from "react-redux";
import { Button } from "react-ui";
import { useState } from "react";

import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { createAbsolute } from "../../../../../Common/ModelPath/ModelPath";

export interface RecalculateButtonContainerProps {
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: RecalculateButtonContainerProps) => {
    const firstPathInModel = Object.keys(state.viewModel)[0];
    const valueOfDirtyMasks =
        firstPathInModel != undefined
            ? ownProps.viewModelSelect.pathViewModel(state, createAbsolute(firstPathInModel))?.dirtyChangedPathMasks
            : undefined;
    return {
        visible: valueOfDirtyMasks != undefined,
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    onClick: async () => {
        await dispatch(async (_, __, form) => {
            await form.normalizeDirtyMasksAndReloadInnerIfRequired();
        });
    },
});

interface RecalculateButtonProps {
    visible: boolean;
    onClick: () => Promise<void>;
}

const RecalculateButton = (props: RecalculateButtonProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const onClick = async () => {
        if (isLoading) {
            return;
        }
        try {
            setIsLoading(true);
            await props.onClick();
        } finally {
            setIsLoading(false);
        }
    };
    return props.visible ? (
        <Button width="100%" warning={true} onClick={onClick} loading={isLoading}>
            Пересчитать
        </Button>
    ) : (
        <></>
    );
};

export const RecalculateButtonContainer = withResolvePaths(
    withViewModelSelect(connect(mapStateToProps, mapDispatchToProps)(RecalculateButton))
);
